// extracted by mini-css-extract-plugin
export var container = "_mg-0";